import { QueryOptions } from "../../Common/useQuery";
import useUserQuery from "../../Common/useUserQuery";
import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";

export type PurchaseOrderDto = {
  id: string;
  number: string;
  supplierId: string;
  supplierName: string;
  productId: string;
  productName: string;
  purchased: number;
  unit: string;
  ticketNotes?: string;
  siteId?: string;
  siteName?: string;
  hasTransactions: boolean;
  received?: number;
}

export type PathParams = {
  completed: boolean,
}

const useGetPurchaseOrders = (params: PathParams, options?: QueryOptions<PurchaseOrderDto[]>) => {
  const business = useSelectedBusiness();
  const baseUrl = `/api/businesses/${business.id}/purchaseOrders`;
  const urlParams = new URLSearchParams();

  urlParams.append('completed', params.completed.toString());

  return useUserQuery<PurchaseOrderDto[]>(
    { path: `${baseUrl}?${urlParams.toString()}` },
    options);
}

export default useGetPurchaseOrders;
